// Date helpers moved verbatim from the legacy OnlineLecturePanel.
// dateChange produces the wall-clock time the backend expects
// (local time rendered as ISO WITHOUT a timezone suffix) — do not "fix" to real UTC.

export const dateChange = (lectureInfo) => {
    const dateObj = new Date(lectureInfo);

    const gmtTime = dateObj.getTime() - dateObj.getTimezoneOffset() * 60000;
    const gmtDateObj = new Date(gmtTime);

    const isoDateString = gmtDateObj.toISOString();

    // strip ".mmmZ" — backend expects no milliseconds and no timezone designator
    return isoDateString.slice(0, -5);
};

export const dateFormatDisplay = (lectureDate) => {
    const date = new Date(lectureDate);
    return date.toLocaleDateString("tr-TR", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
    });
};
